import type { ApiPage } from 'src/core/models/api/ApiPage';

/**
 * Whether this page is the one the app fills with the participant's own favourites.
 *
 * The backend says so with a flag, so a beheerder may name the page whatever fits their event (#431). An
 * event served by an older backend carries no flag; there the name it was created with still decides.
 */
export default function isFavoritesPage(page: Pick<ApiPage, 'name' | 'data'> | undefined | null): boolean {
	if (!page) return false;

	const flag = (page.data as { is_favorites?: boolean } | undefined)?.is_favorites;

	return flag ?? page.name === 'Mijn timetable';
}
